import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import AdminUsers from './pages/AdminUsers';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { BrandDashboard } from './pages/brand/Dashboard';
import { BrandProducts } from './pages/brand/Products';
import { BrandCampaigns } from './pages/brand/Campaigns';
import { CampaignDetail } from './pages/brand/CampaignDetail';
import DataUpload from './pages/DataUpload';
import SmartAnalytics from './pages/SmartAnalytics';

// Dashboard Section Pages
import { OperationalPerformance } from './pages/brand/dashboard/OperationalPerformance';
import { StockReporting } from './pages/brand/dashboard/StockReporting';
import { SalesPerformance } from './pages/brand/dashboard/SalesPerformance';
import { UsageAnalytics } from './pages/brand/dashboard/UsageAnalytics';
import { RetailMedia } from './pages/brand/dashboard/RetailMedia';

// Detail Pages
import { AllCriticalMachines } from './pages/brand/dashboard/details/AllCriticalMachines';
import { AllCriticalProducts } from './pages/brand/dashboard/details/AllCriticalProducts';
import { AllTopMachines } from './pages/brand/dashboard/details/AllTopMachines';
import { AllBottomMachines } from './pages/brand/dashboard/details/AllBottomMachines';
import { AllTopProducts } from './pages/brand/dashboard/details/AllTopProducts';
import { AllBottomProducts } from './pages/brand/dashboard/details/AllBottomProducts';

function Home() {
  return (
    <main className="flex flex-col items-center justify-center p-6">
      <div className="w-24 h-24 mb-6 bg-blue-600 rounded-lg flex items-center justify-center">
        <span className="text-white text-2xl font-bold">BB</span>
      </div>
      <h1 className="text-4xl font-bold mb-4">Bright Blue Cloud</h1>
      <p className="text-muted-foreground mb-6">Multi-tenant Analytics Platform</p>
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-4">
          Welcome to your analytics dashboard. Use the navigation above to access your data.
        </p>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<ResetPassword />} />
      
      {/* Brand Routes */}
      <Route path="/brand/:brandId/dashboard" element={<ProtectedRoute roles={["brand"]}><BrandDashboard /></ProtectedRoute>} />
      <Route path="/brand/:brandId/products" element={<ProtectedRoute roles={["brand"]}><BrandProducts /></ProtectedRoute>} />
      <Route path="/brand/:brandId/campaigns" element={<ProtectedRoute roles={["brand"]}><BrandCampaigns /></ProtectedRoute>} />
      <Route path="/brand/:brandId/campaigns/:id" element={<ProtectedRoute roles={["brand"]}><CampaignDetail /></ProtectedRoute>} />
      
      {/* Dashboard Section Routes */}
      <Route path="/brand/:brandId/dashboard/operational" element={<ProtectedRoute roles={["brand"]}><OperationalPerformance /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/stock" element={<ProtectedRoute roles={["brand"]}><StockReporting /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/sales" element={<ProtectedRoute roles={["brand"]}><SalesPerformance /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/usage" element={<ProtectedRoute roles={["brand"]}><UsageAnalytics /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/media" element={<ProtectedRoute roles={["brand"]}><RetailMedia /></ProtectedRoute>} />
      
      {/* Detail Page Routes */}
      <Route path="/brand/:brandId/dashboard/stock/machines/all" element={<ProtectedRoute roles={["brand"]}><AllCriticalMachines /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/stock/products/all" element={<ProtectedRoute roles={["brand"]}><AllCriticalProducts /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/sales/top-machines/all" element={<ProtectedRoute roles={["brand"]}><AllTopMachines /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/sales/bottom-machines/all" element={<ProtectedRoute roles={["brand"]}><AllBottomMachines /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/sales/top-products/all" element={<ProtectedRoute roles={["brand"]}><AllTopProducts /></ProtectedRoute>} />
      <Route path="/brand/:brandId/dashboard/sales/bottom-products/all" element={<ProtectedRoute roles={["brand"]}><AllBottomProducts /></ProtectedRoute>} />
      
      {/* Admin Routes */}
      <Route path="/admin/users" element={<ProtectedRoute roles={["admin"]}><AdminUsers /></ProtectedRoute>} />
      
      {/* Data Upload Route */}
      <Route path="/data/upload" element={<ProtectedRoute roles={["admin", "brand"]}><DataUpload /></ProtectedRoute>} />
      
      {/* Smart Analytics Route */}
      <Route path="/analytics" element={<ProtectedRoute roles={["admin", "brand"]}><SmartAnalytics /></ProtectedRoute>} />
    </Routes>
  );
}
